export class PackageType {
    constructor(private _packageTypeId: string, private _description: string) {

    }

    get packageTypeId(): string {
        return this._packageTypeId;
    }

    set packageTypeId(val : string ) {
        this._packageTypeId = val;
    }

    get description(): string {
        return this._description;
    }

    set description(val: string) {
        this._description = val;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/packageDialog/models/packageType.ts
 **/